import { useEffect, useState } from 'react';

interface Subscribable<T> {
  subscribe: (next: (value: T) => void) => { unsubscribe: () => void };
}

/** Subscribes to an Observable (WatermelonDB query .observe()) and returns its latest value. */
export function useObservable<T>(factory: () => Subscribable<T> | null, deps: ReadonlyArray<unknown>, initial: T): T {
  const [value, setValue] = useState<T>(initial);
  useEffect(() => {
    const obs = factory();
    if (!obs) return;
    const sub = obs.subscribe(setValue);
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return value;
}
